import { CircularProgress as MuiCircularProgress } from '@mui/material';
import type { CircularProgressProps } from '@mui/material/CircularProgress';
import type { ReactElement } from 'react';

export const CircularProgress = ({
  'aria-label': ariaLabel = 'Loading',
  ...props
}: CircularProgressProps): ReactElement => (
  <MuiCircularProgress aria-label={ariaLabel} {...props} />
);

export type { CircularProgressProps } from '@mui/material/CircularProgress';
